<div class="page-container reserve-result-content">

  <div class="reserve-result-card-area">
    <!-- 方案卡牌區 -->
    <!--block:分析結果-->
      <div class="reserve-title-block">
        <!--標題title-->
          <h2 class="page-title">{{ 'reserve-result.title' | translate }}</h2>
          <p>{{ 'reserve-result.subtitle' | translate }}
            <app-tag size="xs" color="outline-green2">
            <app-text size="specialM" weight="m" color="green-700">{{ 'reserve-result.belongs-to-checkup' | translate }}</app-text>
            </app-tag>
          </p>
        
        @if (healthPlan === 'special') {
            <button mat-button class="btn-fill-primary btn-size-m download-plan-btn"
            [disabled]="isDownloadSpecialUserPlan" 
            (click)="downloadSpecialUserPlan()">
              <img width="24" height="24" src="assets/img/i-download.svg" alt="download" />
              {{ 'reserve-result.download-healthPlan' | translate }}
            </button>
        }

      </div>
    <!--三種方案卡片顯示的區塊-->
      <div class="reserve-card-block">
        <!--方案:全方位健檢-->
        <div class="reserve-plan-card" 
            [ngClass]="{'from-health-plan': healthPlan === 'special'}">
        <div class="package-tag">
          <app-tag size="xs" color="outline-green2">
            <app-text size="specialM" weight="m" color="green-700">{{ 'reserve-result.belongs-to-checkup' | translate }}</app-text>
          </app-tag>
        </div>

          <div class="reserve-plan-allcheckup">
            <div class="package-bio">
                <app-text size="special3" color="gray-900" >
                  {{ 'reserve-result.all-checkup' | translate }}
                </app-text>

                @if (healthPlan !== 'special') {
                    <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
                      ${{ allCheckup?.discountedPlanPrice | numberComma }}
                      <!-- {{ calculatedAllCheckupPrice | numberComma }} -->
                    </app-text>
                  <div class="reserve-plan-subtitle">
                    <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.all-checkup-text' | translate }}</app-text>
                  </div>
                  <app-tag size="lg" color="outline-gray2" [clickable]="true"
                    (clicked)="choosePackage(0) ">
                    <app-text size="m" weight="m" color="gray-700">
                      {{ 'reserve-result.choose-this-package' | translate }}
                    </app-text>
                  </app-tag>
                }@else {
                  <!-- 活動頁面 -->
                  <div class="reserve-plan-subtitle">
                    <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.all-checkup-text' | translate }}</app-text>
                  </div>
                }
            </div>
            
          </div>
          <div class="reserve-plan-checkup-item reserve-plan">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <div>
                <app-text size="reportItem" weight="m" color="gray-900">{{ 'reserve-result.standard-1' | translate }}</app-text>
                <app-text size="reportItem" weight="l" color="gray-900">{{ 'reserve-result.standard-2' | translate }} </app-text>
              </div>
          </div>

          <!-- 標籤 -->
          <div class="reserve-plan">
            <div class="reserve-common-block">
              <img width="24" height="24" src="assets/img/i-special-checkup.svg" />
              <app-text size="reportItem" weight="l" color="gray-900">{{ 'reserve-result.special-checkup-hint' | translate }}</app-text>
            </div>
            <div class="tagList">
              <app-tag-list [tags]="allCheckupTagList" />
            </div>
            <div class="reserve-plan-checkup">
              @if (Number(allCheckup?.potentialCnt ?? 0) > 0) {
                <div class="reserve-plan-checkup-item">
                  <img width="24" height="24" src="assets/img/i-check-green.svg" />
                  <app-text size="category-text" color="gray-700">
                    {{ 'reserve-result.potential-1' | translate }}
                    {{ allCheckup?.potentialCnt }}{{ 'reserve-result.item' | translate }}
                    {{ 'reserve-result.potential-2' | translate }}
                  </app-text>
                </div>
              }

              @if (Number(allCheckup?.abnormalCnt ?? 0) > 0) {
                <div class="reserve-plan-checkup-item">
                  <img width="24" height="24" src="assets/img/i-check-green.svg" />
                  <app-text size="category-text" color="gray-700">
                    {{ 'reserve-result.abnormal-1' | translate }}
                    {{ allCheckup?.abnormalCnt
                    }}{{ 'reserve-result.item' | translate }}
                    {{ 'reserve-result.abnormal-2' | translate }}
                  </app-text>
                </div>
              }
            </div>
            
          </div>

          <!-- 高階影像 -->
          <div class="imageItem-area">
            <div class="reserve-common-block">
              <img width="24" height="24" src="assets/img/i-brain.svg" />
              <app-text size="m" weight="l" color="gray-900">{{ 'reserve-result.advanced-imaging-checkup' | translate }}</app-text>
            </div>
            <div class="imageItem-area-item">
              @for (exam of allCheckupAdvancedImagingList; track exam.examItem) {
              <div class="reserve-common-block">
                <img width="24" height="24" src="assets/img/i-check-green.svg" />
                <app-text size="category-text" color="gray-700">{{ exam.examName }}</app-text>
              </div>
              }
            </div>
            
          </div>

        </div>

        <!--方案:智能專屬-->
        <div class="reserve-plan-card" 
            [ngClass]="{'from-health-plan': healthPlan === 'special'}">
            <div class="package-tag">
              <app-tag size="xs" color="outline-green2">
                <app-text size="specialM" weight="m" color="green-700">{{ 'reserve-result.belongs-to-checkup' | translate }}</app-text>
              </app-tag>
            </div>

          <div class="reserve-plan-aiExclusive">
            <div class="package-bio">
              <app-text size="special3" color="gray-900">
              {{ 'reserve-result.ai-exclusive' | translate }}
            </app-text>

            @if (healthPlan !== 'special') {

              <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
                ${{ aiExclusive?.discountedPlanPrice | numberComma }}
                <!-- {{ calculatedAiExclusivePrice | numberComma }} -->
              </app-text>

            <div class="reserve-plan-subtitle">
              <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.ai-exclusive-text' | translate }}</app-text>
            </div>
            <app-tag size="lg" color="filled-green2" [clickable]="true"
            (clicked)="choosePackage(1) ">
              <app-text size="m" weight="m" color="gray-0">
                {{ 'reserve-result.choose-this-package' | translate }}
              </app-text>
            </app-tag>
          }@else{
            <!-- 活動頁面 -->
            <div class="reserve-plan-subtitle">
              <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.ai-exclusive-text' | translate }}</app-text>
            </div>
          }
            </div>
            
          </div>
          <div class="reserve-plan-checkup-item reserve-plan">
              <img width="24" height="24" src="assets/img/i-check-green.svg" />
              <div>
                <app-text size="reportItem" weight="m" color="gray-900">{{ 'reserve-result.standard-1' | translate }}</app-text>
                <app-text size="reportItem" weight="l" color="gray-900">{{ 'reserve-result.standard-2' | translate }} </app-text>
              </div>
          </div>

          <!-- 標籤 -->
          <div class="reserve-plan">
            <div class="reserve-common-block">
              <img width="24" height="24" src="assets/img/i-special-checkup.svg" />
              <app-text size="reportItem" weight="l" color="gray-900">{{ 'reserve-result.special-checkup-hint' | translate }}</app-text>
            </div>
            <div class="tagList">
              <app-tag-list [tags]="aiExclusiveTagList" />
            </div>
              <div class="reserve-plan-checkup">
                @if (Number(aiExclusive?.potentialCnt ?? 0) > 0) {
                  <div class="reserve-plan-checkup-item">
                    <img width="24" height="24" src="assets/img/i-check-green.svg" />
                    <app-text size="category-text" color="gray-700">
                      {{ 'reserve-result.potential-1' | translate }}
                      {{ allCheckup?.potentialCnt }}{{ 'reserve-result.item' | translate }}
                      {{ 'reserve-result.potential-2' | translate }}
                    </app-text>
                  </div>
                }

                @if (Number(allCheckup?.abnormalCnt ?? 0) > 0) {
                  <div class="reserve-plan-checkup-item">
                    <img width="24" height="24" src="assets/img/i-check-green.svg" />
                    <app-text size="category-text" color="gray-700">
                      {{ 'reserve-result.abnormal-1' | translate }}
                      {{ allCheckup?.abnormalCnt
                      }}{{ 'reserve-result.item' | translate }}
                      {{ 'reserve-result.abnormal-2' | translate }}
                    </app-text>
                  </div>
                }
              </div>
          </div>
        </div>

        <!--方案:基礎健檢-->
        <div class="reserve-plan-card" 
            [ngClass]="{'from-health-plan': healthPlan === 'special'}">
            <div class="package-tag">
              <app-tag size="xs" color="outline-gray2">
                <app-text size="specialM" weight="m" color="gray-700">通用的檢查</app-text>
              </app-tag>
            </div>

          <div class="plan-basicCheckup">

            <div class="package-bio">
              <app-text size="special3" color="gray-900">
              {{ 'reserve-result.basic-checkup' | translate }}
            </app-text>
            
            @if (healthPlan !== 'special') {
              <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
                ${{ basicCheckup?.discountedPlanPrice | numberComma }}
                <!-- {{ calculatedBasicCheckupPrice | numberComma }} -->
              </app-text>
                
              <div class="reserve-plan-subtitle">
                <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.basic-checkup-text' | translate }}</app-text>
              </div>
            
              <app-tag size="lg" color="outline-gray2" [clickable]="true"
                (clicked)="choosePackage(2) ">
                <app-text size="m" weight="m" color="gray-700" >
                  {{ 'reserve-result.choose-this-package' | translate }}
                </app-text>
              </app-tag>
            }@else{
              <!-- 活動頁面 -->
              <div class="reserve-plan-subtitle">
                <app-text size="reportItem" weight="s" color="gray-700">{{ 'reserve-result.basic-checkup-text' | translate }}</app-text>
              </div>
            }
            </div>
              
          </div>
          <div class="reserve-plan-checkup-item reserve-plan-basicCheckup">
              <img width="24" height="24" src="assets/img/i-check-gray.svg" />
              <app-text size="reportItem" weight="l" color="gray-900">{{ 'reserve-result.standard-1' | translate }}</app-text>
            </div>          
          </div>
      </div>

  </div>

  <div class="reserve-plan-block">
    <!--方案差異區域-->
    <div class="reserve-table-block">
      <!--title 標題-->
      <div class="page-title-block">
        <div class="page-subtitle-block">
          <img
            width="32"
            height="32"
            ngSrc="assets/img/i-light.svg"
            alt="light"
          />
          @if (healthPlan === 'special') {
            <p>{{ 'reserve-result.special-package-hint' | translate }}</p>
          } @else {
          <p>{{ 'reserve-result.package-hint' | translate }}</p>
          }
        </div>
        <div class="page-title-with-button">
          <h2 class="page-title">
            {{ 'reserve-result.package-difference' | translate }}
          </h2>
          @if (healthPlan !== 'special') {
            <button mat-button class="btn-text-primary btn-size-m" (click)="downloadUserPlan()">
              {{ 'reserve-result.download-healthPlan-usual' | translate }}
              <img width="24" height="24" src="assets/img/download-usual.png" alt="download" />
            </button>
          }
          <!-- 測試用 -->
          <!-- <video #video autoplay playsinline></video>

          <button mat-button (click)="openCamera()">
            開啟前鏡頭
          </button>

          <button mat-button (click)="stopCamera()">
            關閉鏡頭
          </button> -->

        </div>
      </div>

      <!--table 表格-->
      <div class="plan-table-block">
        @for (item of allExamInfoGroupByType; track item[0]; let i = $index) {
          <div class="plan-table">
            <!-- table-header 表頭-->
            <div class="plan-table-header">
              <div class="plan-table-header-title">{{ item[0] }}</div>
              <div class="plan-table-header-items">
                <span></span>
                <span></span>
                <span>
                  {{ 'reserve-result.all-checkup' | translate }}
                  @if (getAllCheckupCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getAllCheckupCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
                <span>
                  {{ 'reserve-result.ai-exclusive' | translate }}
                  @if (getAiExclusiveCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getAiExclusiveCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
                <span>
                  {{ 'reserve-result.basic-checkup' | translate }}
                  @if (getBasicCheckupCountByExamTypeIndex(i) > 0) {
                    <div class="plan-count">
                      <p>{{ getBasicCheckupCountByExamTypeIndex(i) }}</p>
                    </div>
                  }
                </span>
              </div>
            </div>

            <!-- table-body 內文-->
            <div class="plan-table-body">
              @for (
                examInfo of item[1];
                track examInfo.examItem;
                let j = $index
              ) {
                @if (j < 3 || isExamInfoGroupByTypeShowAll[i]) {
                  <div class="plan-table-list">
                    <div class="plan-table-list-category">
                      {{ examInfo.deptName }}
                    </div>
                    <div class="plan-table-list-item">
                      <div class="plan-table-list-name">
                        <span>{{ examInfo.examName }}</span>

                        <!--mobile:顯示info按鈕-->
                        <button
                          mat-icon-button
                          type="button"
                          class="btn-icon btn-info"
                          (click)="showExamDialog(examInfo)"
                        >
                          <img
                            width="14"
                            height="14"
                            ngSrc="assets/img/i-info.svg"
                            alt=""
                          />
                        </button>
                      </div>

                      <span class="plan-table-list-memo">{{
                        examInfo.examMemo
                      }}</span>
                      <div class="plan-check">
                        <span></span>
                        <span></span>
                        <span>
                          @if (isAllCheckupChecked(examInfo, item[0])) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                        <span>
                          @if (isAiExclusiveChecked(examInfo, item[0])) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                        <span>
                          @if (isBasicCheckupChecked(examInfo, item[0])) {
                            <img
                              width="20"
                              height="20"
                              ngSrc="assets/img/i-check-green.svg"
                              alt=""
                            />
                          }
                        </span>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>

            @if (item[1].length > 3) {
              <!-- table-footer 展開-->
              <div class="plan-table-footer">
                <button
                  type="button"
                  mat-button
                  class="btn-text-primary btn-size-m"
                  (click)="toggleExamInfoGroupByTypeShowAll(i)"
                >
                  {{
                    isExamInfoGroupByTypeShowAll[i]
                      ? ('reserve-result.less' | translate)
                      : ('reserve-result.more' | translate)
                  }}
                  <img
                    [ngSrc]="
                      isExamInfoGroupByTypeShowAll[i]
                        ? 'assets/img/i-minus.svg'
                        : 'assets/img/i-add.svg'
                    "
                    width="12"
                    height="12"
                    alt="toggle icon"
                  />
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!--block：固定方案區域 當頁面持續下拉至三個卡片消失時 此固定區塊將顯示方便讓使用者點選方案 -->
  <div class="table-fixed-plan-block" [class.active]="isTableFixedActive">
    <div class="table-fixed-content">
      <!--標題區塊-->
      <div class="table-fixed-title-pc">
        <span class="table-fixed-title" [@fadeInOut]="animationKey">{{
        currentTableHeaderTitle
      }}</span>
      </div>
      
      <!--固定方案區塊-->
      <div class="fixed-plan-block">
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.all-checkup' | translate }}
          </h3>
          @if(healthPlan !== 'special') {
            <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
              ${{ allCheckup?.discountedPlanPrice | numberComma }}
              <!-- {{ calculatedAllCheckupPrice | numberComma }} -->
            </app-text>
            <app-tag size="choosePackage" color="outline-gray2" [clickable]="true"
              (clicked)="choosePackage(0) ">
              <app-text size="m" weight="m" color="gray-700">
                {{ 'reserve-result.choose-this-package' | translate }}
              </app-text>
            </app-tag>
          }
        </div>
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.ai-exclusive' | translate }}
          </h3>
          @if(healthPlan !== 'special') {
            <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
              ${{ aiExclusive?.discountedPlanPrice | numberComma }}
              <!-- {{ calculatedAiExclusivePrice | numberComma }} -->
            </app-text>
            <app-tag size="choosePackage" color="filled-green2" [clickable]="true"
              (clicked)="choosePackage(1) ">
              <app-text size="m" weight="m" color="gray-0">
                {{ 'reserve-result.choose-this-package' | translate }}
              </app-text>
            </app-tag>
          }
        </div>
        <div class="fixed-plan">
          <h3 class="reserve-plan-title">
            {{ 'reserve-result.basic-checkup' | translate }}
          </h3>
          @if(healthPlan !== 'special') {
            <app-text size="extra2" weight="xl" color="gray-900" class="reserve-plan-price">
              ${{ basicCheckup?.discountedPlanPrice | numberComma }}
              <!-- {{ calculatedBasicCheckupPrice | numberComma }} -->
            </app-text>
            <app-tag size="choosePackage" color="outline-gray2" [clickable]="true"
              (clicked)="choosePackage(2) ">
              <app-text size="m" weight="m" color="gray-700">
                {{ 'reserve-result.choose-this-package' | translate }}
              </app-text>
            </app-tag>
          }
        </div>
      </div>

      <!-- 手機版 -->
       <div class="table-fixed-title-mobile">
        <span class="table-fixed-title" [@fadeInOut]="animationKey">{{
        currentTableHeaderTitle
      }}</span>
      </div>
    </div>
  </div>
</div>
